import React, { useState, useEffect } from 'react';

import './styles.css';

import bankAccountServices from '../../../../services/admFin/bankAccountServices';

import { Dots } from "react-activity";

import Popup from '../../../../components/Popup';
import Input from '../../../../components/Input';
import { FaArrowUp, FaArrowDown, FaFileInvoiceDollar } from 'react-icons/fa';
import companyServices from '../../../../services/admFin/companyServices';
import collaboratorBillServices from '../../../../services/admFin/collaboratorBill';

export default function PopupNewBill(props) {
    const [auxInfos, setAuxInfos] = useState({});
    const [company, setCompany] = useState("");
    const [collaborator, setCollaborator] = useState("");
    const [description, setDescription] = useState("");
    const [currency, setCurrency] = useState("");
    const [numberInstallments, setNumberInstallments] = useState(1);
    const [formOfPayment, setFormOfPayment] = useState("");
    const [bankAccount, setBankAccount] = useState("");
    const [note, setNote] = useState("");
    const [fetching, setFetching] = useState(false);
    const [installments, setInstallments] = useState([{
        valor: 0,
        data_venc: "",
        paga: false,
        data_pag: "",
        valor_pago: 0
    }]);

    useEffect(() => {
        readInfoNewBill();
    }, []);

    useEffect(() => {
        if(auxInfos.colaboradores) {
            const collaboratorObj = auxInfos.colaboradores.find(item => item.nome === collaborator);
            if(collaboratorObj) {
                setInstallments(oldArray => {
                    return oldArray.map(obj => {
                        obj.valor = collaboratorObj.salario;
                        return obj;
                    });
                    
                })
            }
        }

    }, [collaborator])

    useEffect(() => {
        if (props.data && props.data.id) {
            setCompany(props.data.empresa.nome);
            if(props.data.colaborador)
                setCollaborator(props.data.colaborador.nome);
            setDescription(props.data.descricao);

            setCurrency(props.data.moeda);
            setNumberInstallments(props.data.numero_parcelas);
            setInstallments(props.data.parcelas.filter(obj => obj.paga === false));

            if (props.data.forma_de_pagamento) setFormOfPayment(props.data.forma_de_pagamento.nome);
            else setFormOfPayment("");

            if(props.data.conta_bancaria)
                setBankAccount(`${props.data.conta_bancaria.id}: ${bankAccountServices.formatBankAccount(props.data.conta_bancaria)}`);
            setNote(props.data.obs);
        } else
            cleanStates();
    }, [props.data]);


    useEffect(() => {
        if (company) {
            const temp = auxInfos.empresas.find(empresa => empresa.nome === company);
            if (temp)
                setCurrency(temp.moeda);
        }
    }, [company]);

    function onBlurNumberInstallments(e) {
        let collaboratorObj = undefined;
        if(auxInfos.colaboradores) {
            collaboratorObj = auxInfos.colaboradores.find(item => item.nome === collaborator);
        }
        if (props.data.numero_parcelas && numberInstallments < props.data.numero_parcelas_pagas) {
            alert("Não é permitido atualizar a conta com menos parcelas que o número de parcelas já pagas");
            setNumberInstallments(props.data.numero_parcelas)
            setInstallments(props.data.parcelas.filter(obj => obj.paga === false));
            return;
        }
        if (props.data.numero_parcelas) {
            if (numberInstallments - props.data.numero_parcelas_pagas > installments.length) {
                setInstallments(oldArray => {
                    const temp = [...oldArray];
                    while (numberInstallments - props.data.numero_parcelas_pagas > temp.length) {
                        temp.push({
                            valor: collaboratorObj ? collaboratorObj.salario : 0,
                            data_venc: "",
                            paga: false,
                            data_pag: "",
                            valor_pago: 0
                        });
                    }
                    return temp
                });
            }
            else if (numberInstallments - props.data.numero_parcelas_pagas < installments.length) {
                setInstallments(oldArray => {
                    const temp = [...oldArray];
                    while (numberInstallments - props.data.numero_parcelas_pagas < temp.length) {
                        temp.pop();
                    }
                    return temp;
                });
            }

        }
        else {
            if (numberInstallments > installments.length) {
                setInstallments(oldArray => {
                    const temp = [...oldArray];
                    while (numberInstallments > temp.length) {
                        temp.push({
                            valor: collaboratorObj ? collaboratorObj.salario : 0,
                            data_venc: "",
                            paga: false,
                            data_pag: "",
                            valor_pago: 0
                        });
                    }
                    return temp
                });
            }
            else if (numberInstallments < installments.length) {
                setInstallments(oldArray => {
                    const temp = [...oldArray];
                    while (numberInstallments < temp.length) {
                        temp.pop();
                    }
                    return temp;
                });
            }
        }
    }

    async function readInfoNewBill() {
        const response = await collaboratorBillServices.getInfoNewBill();
        if (response.status === 200) {
            setAuxInfos(response.data);
        } else
            alert("Erro ao ler informações auxiliares 4, tente novamente!");
    }

    async function createBill() {
        if ( company && collaborator && description && numberInstallments && currency && installments.length > 0 && formOfPayment && ((formOfPayment.toLowerCase() !== "dinheiro" &&  bankAccount) || formOfPayment.toLowerCase() === "dinheiro")) {
            setFetching(true);
            
            const response = await collaboratorBillServices.postBill(
                auxInfos.empresas.find(item => item.nome === company).id,
                collaborator ? auxInfos.colaboradores.find(item => item.nome === collaborator).id : "",
                description,
                companyServices.moedaTypes.find(obj => obj[1] === currency)[0],
                numberInstallments,
                installments,
                auxInfos.formas_de_pagamento.find(item => item.nome === formOfPayment).id,
                Number(bankAccount.split(":")[0]),
                note,
                false,
            );
            setFetching(false);
            if (response.status === 201) {
                if (props.onCreate) props.onCreate();
                props.setVisibility(false);
                cleanStates();
            } else
                alert("Erro ao criar conta, tente novamente!");
        } else
            alert("Preencha os dados obrigatórios");
    }

    async function updateBill() {
        if (company && collaborator && description && currency && numberInstallments && formOfPayment && ((formOfPayment.toLowerCase() !== "dinheiro" &&  bankAccount) || formOfPayment.toLowerCase() === "dinheiro")) {
            setFetching(true);
            
            const response = await collaboratorBillServices.pathcBill(
                props.data.id,
                auxInfos.empresas.find(item => item.nome === company).id,
                collaborator ? auxInfos.colaboradores.find(item => item.nome === collaborator).id : "",
                description,
                companyServices.moedaTypes.find(obj => obj[1] === currency)[0],
                numberInstallments,
                installments,
                auxInfos.formas_de_pagamento.find(item => item.nome === formOfPayment).id,
                Number(bankAccount.split(":")[0]),
                note
            );
            setFetching(false);
            if (response.status === 200) {
                if (props.onUpdate) props.onUpdate(response.data);
                props.setVisibility(false);
            } else
                alert("Erro ao editar conta, tente novamente!");
        } else
            alert("Preencha os dados obrigatórios");
    }

    function cleanStates() {
        setCompany("");
        setCollaborator("");
        setDescription("");
        setCurrency("");
        //setValue(0);
        setNumberInstallments(1);
        setInstallments([{
            valor: 0,
            data_venc: "",
            paga: false,
            data_pag: "",
            valor_pago: 0
        }]);
        setFormOfPayment("");
        setBankAccount("");
        //setDueDate("");
        setNote("");
    }

    return (
        <>
            <Popup
                visibility={props.visibility}
                setVisibility={props.setVisibility}
                icon={<FaArrowUp />}
                tittle={`${props.data && props.data.id ? "Editar" : "Nova"} conta de colaborador`}
            >
                <form>


                    <Input
                        label='Colaborador*'
                        type='select'
                        options={auxInfos.colaboradores ? auxInfos.colaboradores.map(item => item.nome) : []}
                        id='popup-new-bill-collaborator'
                        onChange={(event) => setCollaborator(event.target.value)}
                        value={collaborator}
                    />
                    <Input
                        label='Empresa*'
                        type='select'
                        options={collaborator && auxInfos.colaboradores.find(item => item.nome === collaborator)? auxInfos.colaboradores.find(item => item.nome === collaborator).empresas.map(item => item.nome) : []}
                        id='popup-new-bill-company'
                        onChange={(event) => setCompany(event.target.value)}
                        value={company}
                    />
                    <Input
                        label='Descrição*'
                        placeholder="Insira uma descrição"
                        type='textarea'
                        id='popup-new-bill-description'
                        onChange={(event) => setDescription(event.target.value)}
                        value={description}
                    />

                
                    <div className='line'>
                        {/* <Input
                        label='Valor da Parcela*'
                        type="currency"
                        currency={currency}
                        placeholder="Insira um valor"
                        id='popup-new-bill-value'
                        onChange={(event) => setValue(event.target.value)}
                        value={value}
                    /> */}
                        <Input
                            label='Número de Parcelas*'
                            type="number"
                            min={1}
                            max={24}
                            placeholder="Insira um valor"
                            id='popup-new-bill-installments'
                            onChange={(event) => setNumberInstallments(event.target.value)}
                            value={numberInstallments}
                            onBlur={onBlurNumberInstallments}
                        />
                        <Input
                            label='Forma de pag.*'
                            type='select'
                            options={auxInfos.formas_de_pagamento ? auxInfos.formas_de_pagamento.map(item => item.nome) : []}
                            id='popup-new-bill-payment'
                            onChange={(event) => setFormOfPayment(event.target.value)}
                            value={formOfPayment}
                        />
                    </div>
                    <Input
                        label={`Conta bancária${formOfPayment.toLowerCase() !== "dinheiro" ? "*" : ""}`}
                        type='select'
                        options={company && auxInfos.empresas && auxInfos.empresas.find(item => item.nome === company) ?
                            auxInfos.empresas
                                .find(item => item.nome === company).contas_bancarias
                                .map(item => `${item.id}: ${bankAccountServices.formatBankAccount(item)}`)
                            : []
                        }
                        id='popup-new-bill-bank'
                        onChange={(event) => setBankAccount(event.target.value)}
                        value={bankAccount}
                    />
                    {/* <Input
                    label="Vencimento*"
                    type='date'
                    id='popup-new-bill-due-date'
                    onChange={(event) => setDueDate(event.target.value)}
                    value={dueDate}
                /> */}
                    <Input
                        label='Observação'
                        placeholder="Insira uma observação"
                        type='textarea'
                        id='popup-new-bill-note'
                        onChange={(event) => setNote(event.target.value)}
                        value={note}
                    />
                    {
                        numberInstallments ?
                            installments.map((obj, idx) => (
                                <div key={idx}>
                                    <div className='line' >
                                        <Input
                                            label={`Vencimento Parcela ${/* props.data.parcelas ? idx+1+(props.data.parcelas.length - installments.length) : */  idx + 1}*`}
                                            type='date'
                                            id='popup-new-bill-due-date'
                                            onChange={(event) => {
                                                setInstallments(oldArray => {
                                                    const temp = [...oldArray];
                                                    temp[idx].data_venc = event.target.value;
                                                    return temp;
                                                })
                                            }}
                                            value={installments[idx].data_venc}
                                        />
                                        <Input
                                            label={`Valor Parcela ${/* props.data.parcelas ? idx+1+(props.data.parcelas.length - installments.length) : */  idx + 1}*`}
                                            type="currency"
                                            currency={currency}
                                            placeholder="Insira um valor"
                                            id='popup-new-bill-value'
                                            onChange={(event) => {
                                                setInstallments(oldArray => {
                                                    const temp = [...oldArray];
                                                    temp[idx].valor = event.target.value;
                                                    return temp;
                                                })
                                            }}
                                            value={installments[idx].valor}
                                        />
                                    </div>
                                        <Input
                                            label="Parcela já foi paga?"
                                            type="checkbox"
                                            placeholder="Sim"
                                            id='popup-new-bill-paid'
                                            onChange={(event) => {
                                                setInstallments(oldArray => {
                                                    const temp = [...oldArray];
                                                    temp[idx].paga = !temp[idx].paga;
                                                    return temp;
                                                })
                                            }}
                                            value={installments[idx].paga}
                                            checked={installments[idx].paga}
                                        />
                                        {
                                            installments[idx].paga ?
                                            <div className='line' >
                                                <Input
                                                    label={`Data Pagamento Parcela ${/* props.data.parcelas ? idx+1+(props.data.parcelas.length - installments.length) : */  idx + 1}*`}
                                                    type='date'
                                                    id='popup-new-bill-date-payment'
                                                    onChange={(event) => {
                                                        setInstallments(oldArray => {
                                                            const temp = [...oldArray];
                                                            temp[idx].data_pag = event.target.value;
                                                            return temp;
                                                        })
                                                    }}
                                                    value={installments[idx].data_pag}
                                                />
                                                <Input
                                                    label={`Valor Pago Parcela ${/* props.data.parcelas ? idx+1+(props.data.parcelas.length - installments.length) : */  idx + 1}*`}
                                                    type="currency"
                                                    currency={currency}
                                                    placeholder="Insira um valor"
                                                    id='popup-new-bill-value-paid'
                                                    onChange={(event) => {
                                                        setInstallments(oldArray => {
                                                            const temp = [...oldArray];
                                                            temp[idx].valor_pago = event.target.value;
                                                            return temp;
                                                        })
                                                    }}
                                                    value={installments[idx].valor_pago}
                                                />
                                            </div>
                                            :
                                            null
                                        }
                                </div>
                            ))
                            :
                            null
                    }
                    <button
                        type="button"
                        onClick={() => fetching ? alert("Um envio já está em andamento.") : (props.data && props.data.id ? updateBill() : createBill())}
                    >
                        {
                            fetching ?
                                <Dots />
                                : (props.data && props.data.id ? "Salvar" : "Adicionar")
                        }
                    </button>
                </form>
            </Popup>
        </>
    )
}